export const GOOGLE_DRIVE_URL = 'https://drive.google.com/';

export const fixedInputHeight = 90;
export const jaUSAId = 999999;
